import axios from "axios";
import Config from "src/config";

const v2_actionEditarUsuario = (usuarioId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/usuarios/${usuarioId}/editar`,
        data
    });
};

export default v2_actionEditarUsuario;
